









import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseComponent from '../BaseComponent.vue';
@Component

export default class FreeTextFeedback extends BaseComponent {
    @Prop() title?: string;
    @Prop() description?: string;
    @Prop() freeTextData?: any;
    @Prop() feedbackTitle?: any;
    @Prop() feedbackDescription?: any;

}
